import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import * as SETAPI from 'cd-eft/services/eftSetApi';

const designController = SETAPI.DesignElementController;
const designStore = stores.AppStore?.designStore;

export class DesignSettingsVM {
  @observable surfaceExpressMode: boolean = designStore.surfaceExpressMode;
  @observable cellSize: number = 100;
  @observable error: boolean = false;
  @observable errorMessage: string = '';

  @observable distanceAdd = designStore.maxAddBorderPointDistance;
  @observable distanceDelete = designStore.maxDeleteBorderPointDistance;
  @observable swithAiHumanFeedback = designStore.shouldHumanFeedbackOn;
  @observable switchAiZoomToAction = designStore.shouldAiZoomToAction;


  @action.bound expressModeSwitchHandler() {
    this.surfaceExpressMode = !this.surfaceExpressMode;
  }

  @action.bound toggleHumanFeedbackSwitch() {
    this.swithAiHumanFeedback = !this.swithAiHumanFeedback;
    designStore.shouldHumanFeedbackOn = this.swithAiHumanFeedback
  }

  @action.bound toggleAiZoomToAction() {
    this.switchAiZoomToAction = !this.switchAiZoomToAction;
    designStore.shouldAiZoomToAction = this.switchAiZoomToAction
  }

  @action.bound activateAiMode() {
    designStore.shouldHumanFeedbackOn = true;
  }

  @action.bound deactivateAiMode() {
    designStore.shouldHumanFeedbackOn = false;
  }

  @action.bound handleGridChange(event) {
    const { target } = event;
    let { value } = target;
    // if value is number keep it a number
    if (!isNaN(parseFloat(value)) && isFinite(value)) {
      value = +value;
    }

    this.cellSize = value;
  }

  @action.bound togglePopupHandler() {
    designStore.showSettingsPopup = !designStore.showSettingsPopup;
  }

  @action.bound saveSettingsHandler() {
    designStore.surfaceExpressMode = this.surfaceExpressMode;
    designStore.showSettingsPopup = false;

    designStore.maxAddBorderPointDistance = this.distanceAdd;
    designStore.maxDeleteBorderPointDistance = this.distanceDelete;

    this.updateStakeOutGrid();
  }

  @action.bound async updateStakeOutGrid() {
    const postUpdateStakeOutGridJSON = {
      surfaceDesignElementId: designStore.currentSurface.designElementId,
      cellHeight: this.cellSize,
      cellWidth: this.cellSize,
    };
    this.error = false;
    try {
      const response = await designController.updateSurfaceStakeOutGridUsingPOST(postUpdateStakeOutGridJSON);
      // console.log('updateStakeOutGrid response:', response);
    } catch (error) {
      this.error = true;
      console.error('Error:', error);
      this.errorMessage = `${(error as Error).message}`;
    }
  }
}
